module.exports = __webpack_public_path__ + "media/assets/icons/medical_icon-a3911d836b7883aea583b63c12c2a28d.svg";